module.exports = __webpack_public_path__ + "static/img/8.ef6e48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/8.png
// module id = 01Ob
// module chunks = 0